import { render, staticRenderFns } from "./DocTypeManagement.vue?vue&type=template&id=847eab88"
import script from "./DocTypeManagement.vue?vue&type=script&lang=js"
export * from "./DocTypeManagement.vue?vue&type=script&lang=js"
import style0 from "./DocTypeManagement.vue?vue&type=style&index=0&id=847eab88&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports